import { APICallV3Post } from 'reactApp/api/APICall';
import { TWopi } from 'reactApp/api/wopi/WopiAPI.types';

export class WopiEditAPICall extends APICallV3Post<TWopi> {
    _method = 'wopi-go/edit';
}
